<template>
  <v-dialog v-model="dialog" width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="#FFFFFF"
        class="btn-739eec"
        height="38"
        :disabled="roleType != '시스템관리자' && statement == '관리자'"
      >
        {{ statement + " 담당자 선택" }}
      </v-btn>
    </template>
    <v-card class="float-left" height="600" width="500">
      <v-card-title class="text-h5  back-556C96 color-white ">
        <h4>{{ statement }}</h4>
      </v-card-title>
      <perfect-scrollbar style="max-height:430px" class="pt-5">
        <v-card-text
          v-for="list in companyList"
          :key="list.companyId"
          class="ma-0 pa-0 pl-5"
        >
          <v-checkbox
            v-model="conSelected"
            :label="list.companyName"
            :value="list.companyId"
            class="pa-0 ma-0"
          ></v-checkbox>
        </v-card-text>
      </perfect-scrollbar>
    </v-card>
    <v-card class="float-left width-50" height="600">
      <v-card-title class="text-h5  back-556C96 color-white">
        <h4>{{ statement + " 담당자" }}</h4>
        <v-spacer />
        <v-icon @click="dialog = !dialog" color="white">mdi-close</v-icon>
      </v-card-title>
      <perfect-scrollbar style="height:430px" class="pt-5">
        <v-card-text
          v-for="list in userList"
          :key="list.userId"
          class="ma-0 pa-0 pl-5"
        >
          <v-checkbox
            v-model="userSelected"
            :label="list.companyName + '/' + list.userName"
            :value="list.userId"
            class="pa-0 ma-0"
          >
          </v-checkbox>
        </v-card-text>
      </perfect-scrollbar>
      <v-card-actions class="justify-center align-center">
        <v-btn
          color="#3F557D"
          class="color-white"
          @click="choiceManager"
          width="150"
          height="40"
        >
          선택완료
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompanyApi from "@/api/CompanyService";
import UserApi from "@/api/UserService";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import Commonality from "@/mixin/Commonality";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
export default {
  mixins: [Commonality],
  components: {
    PerfectScrollbar,
  },
  props: ["statement", "constructionId1", "disabled"],
  async created() {
    let data = {
      constructionId: this.constructionId1,
    };
    let returnData = await CompanyApi.companyTotalList(data);
    this.companyList = returnData.data.companyList.filter(
      (word) => word.companyType == this.statement
    );
    this.initCheckedCompany();
  },
  watch: {
    conSelected: async function(val) {
      await this.selectManager(val);
      this.initCheckedUser();
    },
  },
  computed: {
    roletype() {
      return this.$store.getters.getUserList.roleType;
    },
  },
  methods: {
    async selectManager(val) {
      if (val != null) {
        let data = {
          companyId: val,
          constructionId: this.constructionId1,
        };
        let returnData = await UserApi.userListOnCompany(data);
        const users = returnData.data.userlist;

        /** checked: true && chiefYn: false 요소는 목록에서 미노출 */
        const filteredCompanyList = users.filter(
          (user) => !user.checked || user.chiefYn
        );
        this.userList = filteredCompanyList;

        this.companyIds = val;
      } else {
        this.companyIds = [];
      }
    },
    choiceManager() {
      if (!this.userSelected.length) {
        this.$bus.$emit("dialog", "담당자 선택 후 진행해주세요.");
      }
      let userList = [];

      for (let i = 0; i < this.userList.length; i++) {
        for (let j of this.userSelected) {
          if (this.userList[i].userId == j) {
            userList.push(this.userList[i]);
          }
        }
      }
      let data = {
        manager: userList,
      };
      this.$emit("sendManager", data);
      this.dialog = false;
    },
    /** 회사 체크 세팅 */
    initCheckedCompany() {
      const checkedIdList = this.companyList.map(
        (company) => company.companyId
      );

      this.conSelected = checkedIdList;
    },
    /** 담당자 체크 세팅 */
    initCheckedUser() {
      const checkedIdList = this.userList
        .filter((user) => user.checked)
        .map((user) => user.userId);

      this.userSelected = checkedIdList;
    },
  },
  data: () => ({
    dialog: false,
    companyList: [],
    userList: [],
    conSelected: [],
    userSelected: [],
    companyLists: "",
    statementRoleType: {
      샵업체: "발주담당자",
      가공업체: "입고담당자",
      관리자: "현장관리자",
    },
  }),
};
</script>
